import moment from "moment"
import { Fragment } from "react"
import axios from 'axios'
import { isExternalLinkHasVideoPlatform } from "../../../helpers/helpers";
import UsersService from "../../../Axios/services/users.service";

export const hasVideo = (content: any) => {
    return (content.type === 'external_link' && content.media[0]?.link && isExternalLinkHasVideoPlatform(content.media[0]?.link).hasPlatform) ||
        (content.type === 'file' && content.media[0]?.mimetype?.includes('video'))
}

export const isFileaPhoto = (content: any) => {
    return (content.type === 'file' && content.media[0]?.file && content.media[0]?.mimetype?.includes('image'))
}

export const shouldOpenFileWithLink = (content: any) => {
    return (content.type === 'file' && !hasVideo(content) && !isFileaPhoto(content))
}

export const renderUserName = (item: any, who?: string) => {
    switch (who) {
        case "content_creator":
            return item?.content && item?.content.createdByUser ? (<span onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
            }}>by <span className="highlight">{item?.content.createdByUser.firstName + ' ' + item?.content.createdByUser.lastName}</span></span>) : null
        default:
            return item?.user && item?.user[0] ? (<span onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
            }}>by <span className="highlight">{item?.user[0].firstName + ' ' + item?.user[0].lastName}</span></span>) : null

    }

}


export const renderPublisherName = (item: any, filterFeedByUser: any, who?: string) => {
    switch (who) {
        case "content_creator":
            return item?.content && item?.content.createdByUser ? (<span onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
            }}>by <span className="highlight" onClick={()=>filterFeedByUser(item?.content.createdByUser.fullName)}>{item?.content.createdByUser.firstName + ' ' + item?.content.createdByUser.lastName}</span></span>) : null
        default:
            return item?.user && item?.user[0] ? (<span onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
            }}>by <span className="highlight">{item?.user[0].firstName + ' ' + item?.user[0].lastName}</span></span>) : null

    }

}


export const renderCommunity = (item: any, goToCommunityPage: any) => {
    return item.community && item.community[0] ? <Fragment>
        | &nbsp;
        <span className="postedCommunity" onClick={()=>goToCommunityPage(item.community[0]._id)}>{item.community[0].name}</span>
    </Fragment> : null
}

export const renderSubTitle = (item: any, filterFeedByUser: any, goToCommunityPage: any) => {
    let subTitle;
    if (item.content.type === 'file') {
        subTitle = (
            <div>
                Uploaded  {renderPublisherName(item, filterFeedByUser, 'content_creator')} {moment(item.created).fromNow()} &nbsp; | &nbsp;
                <span className="" >{item.content.title} </span>
            </div>
        )
    }
    else if (item.content.type === 'sefaria_link') {
        subTitle = (
            <div>
                Uploaded {renderPublisherName(item, filterFeedByUser, 'content_creator')} &nbsp; | &nbsp;
                {moment(item.created).fromNow()} &nbsp;
                {renderCommunity(item, goToCommunityPage)}
            </div>
        )
    } else if (item.content.type === "external_link") {
        subTitle = (
            <div>
                External Link {renderPublisherName(item, filterFeedByUser, 'content_creator')} &nbsp; | &nbsp;
                {moment(item.created).fromNow()} &nbsp;
                {renderCommunity(item, goToCommunityPage)}
            </div>
        )
    }
    else if (item.content.type === 'hartman_link') {
        subTitle = (
            <div>
                Article {renderPublisherName(item, filterFeedByUser, 'content_creator')} &nbsp; | &nbsp;
                {moment(item.created).fromNow()} &nbsp;
                {renderCommunity(item, goToCommunityPage)}
            </div>
        )
    } else if (item.content.type === "recording_session") {
        subTitle = (
            <div>
                Session Recording {renderPublisherName(item, filterFeedByUser, 'content_creator')} &nbsp; | &nbsp;
                {moment(item.created).fromNow()} &nbsp;
                {renderCommunity(item, goToCommunityPage)}
            </div>
        )
    } else if (item.content.type === "quick_post") {
        subTitle = (
            <div>
                Posted {renderPublisherName(item, filterFeedByUser)} &nbsp;
                {moment(item.created).fromNow()} &nbsp;
                {renderCommunity(item, goToCommunityPage)}
            </div>
        )
    }
    return subTitle;
}

export const renderSubTitleSearch = (item: any, goToCommunityPage: any) => {
    let subTitle;
    if (item.content.type === 'file') {
        if (hasVideo(item)) {
            subTitle = (
                <div>
                    Video by {renderUserName(item, 'content_creator')} | {moment(item.created).fromNow()} {renderCommunity(item, goToCommunityPage)}
                </div>
            )
        } else {
            subTitle = (
                <div>
                    File by {renderUserName(item, 'content_creator')} | {moment(item.created).fromNow()} {renderCommunity(item, goToCommunityPage)}
                </div>
            )
        }
    }
    else if (item.content.type === 'sefaria_link') {
        subTitle = (
            <div>
                Source sheet by {renderUserName(item, 'content_creator')} | {moment(item.created).fromNow()} {renderCommunity(item, goToCommunityPage)}
            </div>
        )
    } else if (item.content.type === "external_link") {
        if (hasVideo(item)) {
            subTitle = (
                <div>
                    Video {renderUserName(item, 'content_creator')} | {moment(item.created).fromNow()} {renderCommunity(item, goToCommunityPage)}
                </div>
            )
        } else {
            subTitle = (
                <div>
                    External link by {renderUserName(item, 'content_creator')} | {moment(item.created).fromNow()} {renderCommunity(item, goToCommunityPage)}
                </div>
            )
        }
    }
    else if (item.content.type === 'hartman_link') { //article
        subTitle = (
            <div>
                Article by {renderUserName(item, 'content_creator')} | {moment(item.created).fromNow()} {renderCommunity(item, goToCommunityPage)}
            </div>
        )
    } else if (item.content.type === "session_recording") {
        subTitle = (
            <div>
                Session by {renderUserName(item, 'content_creator')} | {moment(item.created).fromNow()} {renderCommunity(item, goToCommunityPage)}
            </div>
        )
    } else if (item.content.type === "quick_post") {
        subTitle = (
            <div>
                Posted by {renderUserName(item)} | {moment(item.created).fromNow()} {renderCommunity(item, goToCommunityPage)}
            </div>
        )
    }
    return subTitle;
}

export const openFile = (url: string, e: any) => {
    e.stopPropagation();
    var string = url;
    var iframe = "<iframe width='100%' height='100%' src='" + string + "'></iframe>"
    var x: any = window.open();
    x.document.open();
    x.document.write(iframe);
    x.document.close();
}

export const navigateToContent = (item: any,navigate :any, setPost?: any) => {
    if ((item.content?.type !== 'quick_post' && item.content?.type !== 'external_link') || hasVideo(item)) {
        navigate(`/content/${item?.content?._id}`)
        if (setPost)
            setPost()
    }
}


export const openLink = (url: string, e: any) => {
    e.stopPropagation();
    window.open(url, '_self');

}

export const sendFileAsAttachment = (url: string, e: any, me: any, setAttachmentSent: any) => {
    setAttachmentSent(true);
    e.stopPropagation();
    UsersService.shareAttachmentToEmail(url, me);

    setTimeout(() => {
        setAttachmentSent(false);
    }, 5000);
}